import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { TableMessagesEnum } from '@table/enums/table-messages.enum';

/**
 * Allow Table classes to make direct calls to the Table component, e.g to clear
 * bulk selections.
 */
@Injectable({ providedIn: 'root' })
export class TableMessageService {
    subject: Subject<TableMessagesEnum> = new Subject();
}
